import { motion } from "framer-motion";

export const BenefitsSection = () => {
  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 },
  };

  const benefits = [
    "Smart Automation: Leverage cutting-edge technology designed specifically for the hospitality industry.",
    "Data-Driven Insights: Stay ahead with real-time analytics that drive better business decisions.",
    "Expert-Backed Solutions: We combine industry expertise with technical innovation to deliver unmatched value.",
    "Customer-First Approach: Your success is our success. We design every solution with your needs in mind.",
  ];

  return (
    <motion.section {...fadeIn} className="space-y-6">
      <h2 className="text-3xl font-semibold text-left">Why Choose Us?</h2>
      <div className="grid md:grid-cols-2 gap-6">
        {benefits.map((benefit, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: index * 0.2 }}
            className="flex items-start gap-3 text-left"
          >
            <div className="text-primary">✅</div>
            <p className="text-lg text-muted-foreground">{benefit}</p>
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
};